const exchangeModal = document.getElementById('exchangeModal');
const createExchangeButton = document.getElementById('createExchange');
exchangeModal.style.display = 'none';

const linkedSaleModal = document.getElementById('linkedSaleModal');
const createLinkedSaleButton = document.getElementById('createLinkedSale');
linkedSaleModal.style.display = 'none';

const bulkLinkedSaleModal = document.getElementById('bulkLinkedSaleModal');
const createBulkLinkedSaleButton = document.getElementById('createBulkLinkedSale');
bulkLinkedSaleModal.style.display = 'none';

// Exchange modal
document.getElementById('createExchange').addEventListener('click', function () {
    exchangeModal.style.display = 'block';
});

document.getElementById('test-exchange-modal').addEventListener('closeChildSaleModal', function(event) {
    exchangeModal.style.display = 'none';
});

document.getElementById('test-exchange-modal').addEventListener('success', function(event) {
  console.log('exchange success', event);
});

// Linked sale modal (single)
document.getElementById('createLinkedSale').addEventListener('click', function () {
    linkedSaleModal.style.display = 'block';
});

document.getElementById('test-linked-sale-modal').addEventListener('closeChildSaleModal', function(event) {
    linkedSaleModal.style.display = 'none';
});

document.getElementById('test-linked-sale-modal').addEventListener('success', function(event) {
  console.log('linked sale success', event);
});

// Bulk linked sale modal
document.getElementById('createBulkLinkedSale').addEventListener('click', function () {
    bulkLinkedSaleModal.style.display = 'block';
});

document.getElementById('test-bulk-linked-sale-modal').addEventListener('closeChildSaleModal', function(event) {
    bulkLinkedSaleModal.style.display = 'none';
});

document.getElementById('test-bulk-linked-sale-modal').addEventListener('success', function(event) {
  console.log('bulk linked sale success', event);
});
